import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import 'mantine-react-table/styles.css';

import {
    ActionsColumn,
    ApnNameColumn,
    CapabilitiesColumn,
    IndexColumn,
    PdpTypeColumn,
} from './columns';
import {
    Box,
    Container,
    Flex,
    Group,
    MultiSelect,
    Portal,
    Select,
    Text,
} from '@mantine/core';
import { useDebouncedCallback, useLocalStorage } from '@mantine/hooks';
import { useMemo, useState } from 'react';

import JsonOptionsColumn from '../../../../common/tables/columns/JsonOptionsColumn';
import { MantineReactTable } from 'mantine-react-table';

const ApnDefinitionsTable = ({ apns }) => {
    const columns = useMemo(
        () => [
            IndexColumn(),
            ApnNameColumn(),
            PdpTypeColumn(),
            CapabilitiesColumn(),
            JsonOptionsColumn({ header: 'IP Routes', accessorKey: 'routes' }),
        ],
        [apns]
    );

    const tableData = useMemo(() => apns || [], [apns]);

    const handleVisibilityChange = (changeFunc) => {
        const changes = changeFunc();
        setColumnVisibility((prevState) => ({
            ...prevState,
            ...changes,
        }));
    };

    const handlSizeChange = (changeFunc) => {
        const changes = changeFunc();
        setColumnSizing((prevState) => ({
            ...prevState,
            ...changes,
        }));
    };

    const handleFilterChange = (queryStr) => {
        filterDebounce(queryStr);
    };

    const tableProps = {
        //expandRowsFn: true, // Assuming this should be true, since it was provided without a value
        columns: columns,
        data: tableData,
        enableSorting: false,
        enableColumnActions: false,
        enableDensityToggle: false,

        editDisplayMode: 'row',
        createDisplayMode: 'row',
        enableHiding: false,
        enableFilters: false,
        enableEditing: true,
        enableResizing: true,
        enableFullScreenToggle: false,
        defaultColumn: {
            minSize: 0,
            maxSize: Number.MAX_SAFE_INTEGER,
        },

        /*onCreatingRowChange: handleNewCreate,
        onCreatingRowSave: handleCreateSave,
        onCreatingRowCancel: handleCreateCancel,
        onEditingRowSave: handleEditSave,
        onEditingRowCancel: handleEditCancel,*/

        //state: { rowSelection },
        mantineTopToolbarProps: () => ({
            //className: classes.toolbar,
        }),
        enableTopToolbar: true,
        /*renderTopToolbarCustomActions: ({ props: table }) => (
            <MessageTableToolbar
                table={table}
                showHidden={showDeleted}
                toggleShowHidden={toggleShowDeleted}
            />
        ),*/
        enableBottomToolbar: false,
        enableRowActions: true,
        positionActionsColumn: 'last',
        positionExpandColumn: 'last',
        mantineTableContainerProps: {
            style: {
                minHeight: '100px',
            },
        },

        /*renderRowActions: ({ table, row }) => ({
            /*<FilterActionsCell
                table={table}
                row={row}
                form={form}
                setTableData={setTableData}
                setRowSelection={setRowSelection}
            /> *
        }),*/
        state: {
            density: 'xs',
        },
        meta: {
            dataLength: tableData.length,
            originalLength: apns?.length || 0,
        },
    };
    return (
        <>
            <MantineReactTable {...tableProps} />
        </>
    );
};
export default ApnDefinitionsTable;
